import React, { useState, useEffect } from 'react';
import '../styles/Experience.css';

export default function Experience() {
  const [experience, setExperience] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/experience')
      .then(res => res.json())
      .then(data => {
        setExperience(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="experience">Loading experience...</div>;
  if (!experience || experience.length === 0) return null;

  return (
    <section id="experience" className="experience">
      <div className="container">
        <h2>Work Experience</h2>
        <div className="experience-timeline">
          {experience.map((job, idx) => (
            <div key={idx} className="experience-item">
              <div className="experience-header">
                <h3>{job.position}</h3>
                <span className="date-badge">{job.date}</span>
              </div>
              <p className="company">{job.company}</p>
              <p className="location">📍 {job.location}</p>
              <ul className="highlights">
                {job.highlights.map((highlight, i) => (
                  <li key={i}>{highlight}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
